<template>
  <div class="admin-content w1000 article-edit-wrapper">
    <div class="ae-sidebar">
      <div class="ae-sidebar-media">
        <ul>
          <li @click="upload('image')">
            <span>图片</span>
            <i class="icon-media icon-media-picture"></i>
          </li>
          <li @click="upload('video')">
            <span>视频</span>
            <i class="icon-media icon-media-video"></i>
          </li>
          <li @click="upload('audio')">
            <span>音频</span>
            <i class="icon-media icon-media-audio"></i>
          </li>
        </ul>
      </div>
    </div>
    <div class="ae-main">
      <el-form ref="form" :model="form" class="ae-main-form">
        <el-form-item>
          <uploadImage v-model="form.imageUrl" @uploaded="imageUploaded" class="upload-cover">
            <div class="article-upload">
              <div class="upload-before" v-if="!form.imageUrl">
                <i class="icon-camera"></i>
                <p>添加封面图片</p>
              </div>
              <div class="upload-after" v-else>
                <img :data-src="form.imageUrl | imageUrl" :src="form.imageUrl | imageUrl">
                <div class="mask" @click.stop></div>
                <div class="panel">
                  <span class="icon-camera-small" title="重新选择"></span>
                  <span class="icon-remove" @click.stop="onRemoveImage" title="删除"></span>
                </div>
              </div>
            </div>
          </uploadImage>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.title" style="font-size:22px;color:#222;" placeholder="请在这里输入标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="form.subject" placeholder="请输入亮点" style="font-size:14px;"></el-input>
        </el-form-item>
      </el-form>
      <div class="article-editor">
        <ueditor v-model="form.content" @ready="ready" @change="change" @selectionchange="selectionchange" ref="editor"></ueditor>
        <div class="bar">
          <el-checkbox v-model="checked">原文链接</el-checkbox>
          <el-input v-model="form.originalUrl" v-if="checked"></el-input>
        </div>
      </div>
    </div>
    <div class="article-footer">
      <div class="inner">
        <div class="buttons">
          <el-button type="primary" @click="onSave">保存</el-button>
          <el-button @click="onPreview">预览</el-button>
          <el-button @click="onPublish">发布</el-button>
          <a href="" id="openPreview" target="_blank"></a>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="420px">
      <span>
        <i class="el-icon-warning" style="color:#eb9e05;font-size:24px;vertical-align:bottom;"></i> 是否保存当前图文消息内容?</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogUnSave">不保存</el-button>
        <el-button size="medium" type="primary" @click="dialogSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ueditor from '../common/ueditor'
import uploadImage from '../common/uploadImage'
import { addArticle, editArticle, getArticleDetail } from '@/api/admin'
// import { Base64 } from 'js-base64'
import { heartbeat } from '@/api/common'
// flagDelete: 0已发布、1已删除、3待处理、6已处理、7下线
// isEdit: true为修改、false为创建
export default {
  components: { ueditor, uploadImage },
  data: () => ({
    pageId: null,
    isEdit: false,
    userInfo: null,
    form: {
      author: '',
      authorId: null,
      title: '',
      imageUrl: '',
      imageWidth: null,
      imageHeight: null,
      originalUrl: '',
      subject: '',
      content: '',
      flagDelete: 0
    },
    checked: false,
    editor: null,
    timer: null,
    autoSaveTimer: null,
    isSave: false,
    siteurl: null,
    dialogVisible: false,
    routerNext: null
  }),
  watch: {
    $route: function(route) {
      this.userInfo =
        (localStorage.getItem('userInfo') &&
          JSON.parse(localStorage.getItem('userInfo'))) ||
        {}
    },
    // 监听数据变化，离开的时候弹框提示
    form: {
      handler: function() {
        this.isSave = false
      },
      deep: true
    }
  },
  created() {
    this.pageId = this.$route.params.id
    this.userInfo =
      (localStorage.getItem('userInfo') &&
        JSON.parse(localStorage.getItem('userInfo'))) ||
      {}
    if (this.pageId) {
      this.isEdit = true
      // 修改渲染
      this.editRender()
    } else {
      // 获取localstorage数据
      let localdata = localStorage.getItem('articleForm')
      localdata && Object.assign(this.form, JSON.parse(localdata))
    }
    this.articleWebTemplate()
    // 开启自动保存数据
    this.autoSaveData()
  },
  methods: {
    // 滚动的时候
    scrollCallback() {
      let sidebar = document.querySelector('.ae-sidebar-media')
      let scrollTop = window.pageYOffset
      scrollTop >= 80
        ? sidebar.classList.add('fixed')
        : sidebar.classList.remove('fixed')
    },
    // 右侧浮动
    bindFixNav() {
      window.addEventListener('scroll', this.scrollCallback)
      window.addEventListener('resize', this.scrollCallback)
      this.scrollCallback()
    },
    // ueditor ready
    ready(editor) {
      this.editor = editor
    },
    change() {
      // console.log('ueditor content change' + this.form.subject)
    },
    selectionchange() {
      // 心跳器
      // this.timer && clearTimeout(this.timer)
      // this.timer = setTimeout(() => {
      //   heartbeat()
      // }, 1000)
      this.heartBeatFn()
    },
    heartBeatFn(flag) {
      if (flag) {
        /* 心跳停止句柄 */
        this.timer && clearTimeout(this.timer)
      } else {
        this.heartBeatFn(true)
        /* 心跳停止开始计时 */
        this.timer = setTimeout(() => {
          heartbeat()
          /* 心跳句柄 */
          this.timer && clearInterval(this.timer)
          this.timer = null
        }, 600000) // 10分钟

        /* 心跳开始计时 */
        if (!this.timer) {
          this.timer = setInterval(() => {
            heartbeat()
          }, 10000) // 10秒
        }
      }
    },
    // 自动保存数据
    autoSaveData() {
      this.autoSaveTimer = setInterval(() => {
        localStorage.setItem('articleForm', JSON.stringify(this.form))
      }, 10000)
    },
    // 图片上传成功
    imageUploaded(imageInfo) {
      this.form.imageWidth = imageInfo.width
      this.form.imageHeight = imageInfo.height
    },
    // 删除封面图片
    onRemoveImage() {
      this.form.imageUrl = ''
      this.form.imageWidth = null
      this.form.imageHeight = null
    },
    upload(type) {
      let videoIframe = this.editor.body.querySelectorAll('iframe.myVideo')
      let audioIframe = this.editor.body.querySelectorAll('iframe.myaudio')
      if (type === 'video' && videoIframe.length >= 3) {
        this.$message.warning('每篇文章最多添加3个视频')
        return false
      } else if (type === 'audio' && audioIframe.length) {
        this.$message.warning('每篇文章只能添加一个语音')
        return false
      }
      this.$refs.editor.upload(type)
    },
    // 修改渲染
    editRender() {
      getArticleDetail({ id: this.pageId }).then(response => {
        let data = response.data || {}
        this.siteurl = data.siteurl
        // 组装数据
        let reslutData = {
          title: data.title || '',
          imageUrl: data.imageUrl || '',
          imageWidth: data.imageWidth || null,
          imageHeight: data.imageHeight || null,
          originalUrl: data.originalUrl || '',
          subject: data.subject || '',
          flagDelete: data.flagDelete
        }
        // 文章内容替换
        data.content &&
          data.content.replace(
            /<div id="zaiart-content">([\s|\S]*?)<div id="authorize"/gi,
            function(p1, p2) {
              reslutData.content = p2
            }
          )
        // 原文链接是否选中
        this.checked = !!data.originalUrl
        // 数据合并
        Object.assign(this.form, reslutData)
        // 设置编辑器内容
        this.editor && this.editor.setContent(this.form.content)
      })
    },
    // 提示——不保存
    dialogUnSave() {
      this.dialogVisible = false
      this.routerNext && this.routerNext()
      // 清除自动保存的数据
      localStorage.removeItem('articleForm')
    },
    // 提示——保存
    dialogSave() {
      this.dialogVisible = false
      this.onSave(this.routerNext)
    },
    // 保存
    onSave(next) {
      if (!this.form.title) {
        this.$message.error('请输入文章标题')
        return false
      }
      // 数据状态为待处理
      this.form.flagDelete = 3
      let saveSuccess = this.isEdit ? this.editArticle() : this.addArticle()
      saveSuccess.then(response => {
        this.$message.success('保存成功')
        if (typeof next === 'function') {
          // 清除自动保存定时器
          this.autoSaveTimer && clearInterval(this.autoSaveTimer)
          // 清除自动保存的数据
          localStorage.removeItem('articleForm')
          next()
        }
      })
    },
    // 预览
    onPreview() {
      if (!this.form.title) {
        this.$message.error('请输入文章标题')
        return false
      }
      // 数据状态为待处理
      this.form.flagDelete = 3
      if (!this.siteurl) {
        this.$confirm('该文章未保存', '提示', {
          confirmButtonText: '保存',
          cancelButtonText: '不保存',
          type: 'warning'
        })
          .then(() => {
            this.onSave()
          })
          .catch(() => {})
        return false
      }
      // 预览先保存
      let saveSuccess = this.isEdit ? this.editArticle() : this.addArticle()
      saveSuccess.then(response => {
        // let openPreview = document.querySelector('#openPreview')
        // openPreview.setAttribute(
        //   'href',
        //   `https://img.zai-art.com/${
        //     this.siteurl
        //   }?t=${+new Date()}`
        // )
        // openPreview.click()
      })
      // 新窗口打开
      let openPreview = document.querySelector('#openPreview')
      openPreview.setAttribute(
        'href',
        `https://img.zai-art.com/${this.siteurl}?t=${+new Date()}`
      )
      openPreview.click()
    },
    // 发布
    onPublish() {
      let errorMessage = ''
      let regUrl = /^[a-zA-Z0-9]{1}[^.]*([a-zA-Z0-9^.]+?)\.[a-zA-Z0-9]+[\s|\S]*[^\-|^_]$/gi

      if (!this.form.title) {
        errorMessage = '请输入文章标题'
      } else if (!this.form.imageUrl) {
        errorMessage = '请上传文章封面图'
      } else if (this.checked && !this.form.originalUrl) {
        errorMessage = '请输入原文链接'
      } else if (this.checked && !regUrl.test(this.form.originalUrl)) {
        errorMessage = '请输入合法链接'
      }

      if (errorMessage) {
        this.$message.error(errorMessage)
        return false
      }

      this.$confirm('文章发布后无法撤销，是否确认发布？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 数据状态为已发布
          this.form.flagDelete = 0
          // 预览先保存
          let saveSuccess = this.isEdit ? this.editArticle() : this.addArticle()
          saveSuccess.then(response => {
            this.$message.success('发布成功')
            this.$router.push('/admin/article')
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消发布'
          })
        })
    },
    // 创建文章
    addArticle() {
      let param = Object.assign({}, this.form, {
        author: this.userInfo.nickName,
        authorId: this.userInfo.id,
        createUid: this.userInfo.id
      })
      param.content = this.articleWebTemplate()
      return addArticle(param).then(response => {
        this.pageId = response.data.id
        this.siteurl = response.data.siteurl
        this.isEdit = true
        this.isSave = true
        return response
      })
    },
    // 修改文章
    editArticle() {
      let param = Object.assign({}, this.form, {
        id: this.pageId,
        author: this.userInfo.nickName,
        authorId: this.userInfo.id,
        createUid: this.userInfo.id
      })
      param.content = this.articleWebTemplate()
      return editArticle(param).then(response => {
        this.siteurl = response.data.siteurl
        this.isEdit = true
        this.isSave = true
        return response
      })
    },
    // 文章模板
    articleWebTemplate() {
      // banner
      let banner =
        (this.form.imageUrl &&
          `<img data-src="${this.form.imageUrl}" src="${
            this.form.imageUrl
          }" data-width="${this.form.imageWidth}" data-height="${
            this.form.imageHeight
          }">`) ||
        ''

      // 发布日期
      let date = new Date()
      let showTime =
        (date.getMonth() + 1 < 9
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) +
        '月' +
        (date.getDate() < 9 ? '0' + date.getDate() : date.getDate()) +
        '日'

      // 原文链接
      let sourceLink = `<div id="sourceLink"><a href="${
        this.form.originalUrl
      }">阅读原文</a></div>`
      let html =
        // <!DOCTYPE html>
        // <html lang="en">
        // <head>
        // <meta charset="UTF-8">
        // <meta name="viewport" content="width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no">
        // <meta http-equiv="X-UA-Compatible" content="ie=edge">
        // <title>${this.form.title}</title>
        // <link rel="stylesheet" href="${
        //   process.env.VUE_APP_ARTICLE_URL
        // }/css/main.min.css">
        // </head>
        // <body>
        // <div class="zaiart-wrapper" id="app" v-lazy-container="{ selector: 'img' }">
        // <div class="loading-gif" v-show="loading">
        // <div class="spinner"><div class="dot1"></div><div class="dot2"></div></div>
        // </div>
        // <div class="main"></div>
        // </div>
        // <script type="text/x-template" id="template">
        `
      <div class="banner">${banner}</div>
      <div class="zaiart-article">
      <div class="title">${this.form.title}</div>
      <div class="publish">
      <div class="author" data-id="${this.userInfo.openId}" data-type="14">
      <div class="pic">
      <div class="inner"><img src="${this.userInfo.logoUrl}" /></div>
      </div><div class="content">${this.userInfo.nickName}</div>
      </div>
      <div class="date">${showTime}</div>
      </div>
      <div class="bright">${
        this.form.subject ? this.form.subject.replace(/\r\n|\n/g, '<br>') : ''
      }</div>
      <div id="zaiart-content">${this.form.content}</div>
      <div id="authorize"></div>
      ${this.checked ? sourceLink : ''}
      </div>`
      // </${'script'}>
      // <script src="${
      //   process.env.VUE_APP_ARTICLE_URL
      // }/js/main.min.js"></${'script'}>
      // </body>
      // </html>`
      return html.replace(/\s{3,}/g, '')
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.bindFixNav()
    })
  },
  // 离开的时候
  beforeRouteLeave(to, from, next) {
    if (this.isSave) {
      next()
      // 清除自动保存的数据
      localStorage.removeItem('articleForm')
    } else {
      next(false)
      this.dialogVisible = true
      this.routerNext = next

      // 浏览器后退有bug，用dialog代替了
      // this.$confirm('是否保存当前图文消息内容?', '提示', {
      //   confirmButtonText: '保存',
      //   cancelButtonText: '不保存',
      //   type: 'warning',
      //   showClose: false,
      //   closeOnHashChange: false,
      //   closeOnClickModal: false
      // }).then(() => {
      //   // 保存成功并离开
      //   this.onSave(next)
      // }).catch(() => {
      //   next()
      //   // 清除自动保存的数据
      //   localStorage.removeItem('articleForm')
      // })
    }
  },
  // 销毁
  destroyed() {
    // 清除自动保存定时器
    this.autoSaveTimer && clearInterval(this.autoSaveTimer)
    window.removeEventListener('scroll', this.scrollCallback)
    window.removeEventListener('resize', this.scrollCallback)
  }
}
</script>
<style>
.article-edit-wrapper {
  padding: 0;
}
.article-edit-wrapper .ae-main-form .el-input__inner,
.article-edit-wrapper .ae-main-form .el-textarea__inner {
  padding-left: 1px;
  padding-right: 1px;
  border: none;
  resize: none;
  font-family: inherit;
}
/* 右侧多媒体部分 */
.article-edit-wrapper .ae-sidebar {
  position: absolute;
  width: 210px;
  right: 0;
  top: 0;
}
.ae-sidebar-media.fixed {
  position: fixed;
  top: 0;
  bottom: 73px;
  width: 210px;
  z-index: 1000;
  overflow-y: auto;
  overflow-x: hidden;
}
.ae-sidebar ul {
  width: 130px;
  padding: 100px 10px;
}
.ae-sidebar li {
  margin-left: 68px;
  height: 42px;
  margin-bottom: 30px;
  padding: 5px;
  font-size: 14px;
  line-height: 32px;
  cursor: pointer;
  position: relative;
  text-align: right;
  border-radius: 32px;
  background-color: #e5e5e5;
  overflow: hidden;
  transition: 0.4s all ease;
}
.ae-sidebar li:hover {
  margin-left: 0;
}
.ae-sidebar li span {
  position: absolute;
  right: 50px;
  top: 5px;
}
.ae-sidebar li .icon-media {
  width: 32px;
  height: 32px;
  vertical-align: top;
  display: inline-block;
}
.ae-sidebar li .icon-media-picture {
  background: url('../../../assets/img/admin/media_picture_hover_icon.png')
    no-repeat;
  background-size: 32px 32px;
}
.ae-sidebar li .icon-media-video {
  background: url('../../../assets/img/admin/media_video_hover_icon.png')
    no-repeat;
  background-size: 32px 32px;
}
.ae-sidebar li .icon-media-audio {
  background: url('../../../assets/img/admin/media_audio_hover_icon.png')
    no-repeat;
  background-size: 32px 32px;
}
.ae-sidebar li:hover .icon-media-picture {
  background-image: url('../../../assets/img/admin/media_picture_icon.png');
}
.ae-sidebar li:hover .icon-media-video {
  background-image: url('../../../assets/img/admin/media_video_icon.png');
}
.ae-sidebar li:hover .icon-media-audio {
  background-image: url('../../../assets/img/admin/media_audio_icon.png');
}
/* 主体部分 */
.article-edit-wrapper .ae-main {
  margin: 0 210px 0 0;
  padding: 30px;
  margin-bottom: 80px;
  border-right: 1px solid #e7e7eb;
}
/* 封面上传 */
.article-edit-wrapper .upload-cover .el-upload {
  display: block;
}
.article-upload {
  position: relative;
  min-height: 226px;
  background-color: #e5e5e5;
}
.article-upload .upload-before {
  position: absolute;
  top: 50%;
  width: 100%;
  height: 70px;
  margin-top: -35px;
  text-align: center;
  line-height: 24px;
  color: #333;
}
.article-upload .icon-camera {
  display: inline-block;
  width: 46px;
  height: 38px;
  background: url('../../../assets/img/admin/camera.png') no-repeat;
  background-size: 100%;
}
.article-upload img {
  width: 100%;
  min-height: 226px;
}
.article-upload .mask {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  cursor: default;
}
.article-upload .panel {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 30px;
  background-color: #5f5d5d;
  z-index: 2;
  cursor: pointer;
}
.article-upload .panel span {
  float: left;
  width: 30px;
  height: 30px;
}
.article-upload .panel .icon-camera-small {
  background: url('../../../assets/img/admin/small_camera.png') no-repeat center
    center;
  background-size: 15px 13px;
}
.article-upload .panel .icon-remove {
  background: url('../../../assets/img/admin/small_delete.png') no-repeat center
    center;
  background-size: 12px 12px;
}
/* 原文链接 */
.article-editor .bar {
  margin: 30px 0;
  padding-top: 30px;
  border-top: 1px solid #e7e7eb;
}
.article-editor .bar .el-input__inner {
  height: 34px;
  padding: 0 10px;
  margin-top: 10px;
  border-radius: 0;
  border: 1px solid #e7e7eb;
}
.article-editor .bar,
.article-editor .bar .el-checkbox,
.article-editor .bar .el-checkbox.is-checked .el-checkbox__label {
  color: #333;
}
.article-editor .bar .el-checkbox__input {
  margin-top: -1px;
}
/* footerbar */
.article-footer {
  position: fixed;
  bottom: 0;
  left: 200px;
  right: 0;
  z-index: 1002;
  background-color: #fff;
  border-top: 1px solid #d9dadc;
}
.article-footer .inner {
  width: 1000px;
  margin: 0 auto;
  padding: 20px 210px;
  overflow: hidden;
}
.article-footer .buttons {
  float: right;
}
.article-footer .buttons .el-button {
  padding: 8px 37px;
}
</style>
